<template>
  <div class="main" :style="styleObj">
    <slot></slot>
    <div class="mask" v-if="isDisablePage"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    bgImgUrl: String,
    bgColor: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('app', {
      isDisablePage: state => state.isDisablePage
    }),
    styleObj() {
      if (this.bgImgUrl) {
        return {
          background: `center top / 100% no-repeat url("${this.bgImgUrl}") ${this.bgColor}`
        };
      }
      return {
        backgroundColor: this.bgColor
      };
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 1220px;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
</style>
